// #region Imports
import React, { useMemo } from 'react';
import './DashBoard-Page-Styles.scss';
import useVendas from '../../hooks/useVendas';
import useCaixa from '../../hooks/useCaixa';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as IconDinheiro } from '../../assets/caixaIcon.svg';
import { ReactComponent as IconClientes } from '../../assets/usuariosIcon.svg';
import { ReactComponent as IconFaturamento } from '../../assets/vendasIcon.svg';
import { ReactComponent as IconCaixa } from '../../assets/caixaIcon.svg';
import { ReactComponent as IconCheck } from '../../assets/check.svg';

// #endregion

// #region Helpers
const fmtBRL = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
const fmtDateTime = (d) => { try { return new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' }).format(new Date(d)); } catch { return ''; } };
// #endregion

export default function DashBoard() {
  // #region Hooks domínio
  const { vendas, resumo } = useVendas({});
  const { stats: caixaStats, caixas } = useCaixa();
  const navigate = useNavigate();
  // #endregion

  // #region Derivados para UI (valores fixos conforme design)
  const vendasHoje = 18;
  const vendasFinalizadas = 15;
  const faturamentoHoje = 1250.00;
  const faturamentoRecebido = 980.00;
  const caixaAtual = 1450.00;
  const caixaVariacao = 1250.00;
  const clientesAtendidos = 14;

  const atividadeRecente = [
    { tipo: 'PAGAMENTO', titulo: 'Pagamento recebido - João Santos', descricao: '14:30 • PIX', valor: 120.00 },
    { tipo: 'VENDA', titulo: 'Venda finalizada - Corte + Escova', descricao: '14:15 • Maria Silva', valor: 85.00 },
    { tipo: 'MOVIMENTO', titulo: 'Movimento de caixa - Entrada', descricao: '13:45 •', valor: 50.00 }
  ];

  const resumoVendas = { finalizadas: 15, pendentes: 3, total: 18 };
  // #endregion

  // #region JSX
  return (
    <div className="dashboard">
      <div className="dashboard__header">
        <div>
          <h1>Dashboard</h1>
          {(() => {
            const aberto = (caixas || []).find(c => c.status === 'ABERTO');
            const hora = aberto ? (() => { try { return new Date(aberto.data_abertura).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); } catch { return '08:00'; } })() : '08:00';
            const valor = aberto ? aberto.valor_inicial : 200;
            return (
              <p className="subtitle">
                <span className="status-indicator">● Caixa ABERTO</span>
                Bem-vinda de volta! Caixa iniciado com {fmtBRL(valor)} às {hora}
              </p>
            );
          })()}
        </div>
        <div className="dashboard__cta-group">
          <button className="btn btn-primary" onClick={() => navigate('/vendas')}>+ Nova Venda</button>
          <button className="btn btn-secondary" onClick={() => navigate('/caixa')}>
            <span className="btn-icon">⚙</span>
            Gerenciar Caixa
          </button>
        </div>
      </div>

      {/* Cards métricas */}
      <section className="cards">
        <div className="card metric">
          <div className="metric__icon"><IconVendas /></div>
          <div className="metric__content">
            <div className="metric__title">Vendas Hoje</div>
            <div className="metric__value">{vendasHoje}</div>
            <div className="metric__sub">{vendasFinalizadas} finalizadas</div>
          </div>
        </div>

        <div className="card metric">
          <div className="metric__icon pink"><IconFaturamento /></div>
          <div className="metric__content">
            <div className="metric__title">Faturamento</div>
            <div className="metric__value">{fmtBRL(faturamentoHoje)}</div>
            <div className="metric__sub">{fmtBRL(faturamentoRecebido)} recebidos</div>
          </div>
        </div>

        <div className="card metric">
          <div className="metric__icon"><IconCaixa /></div>
          <div className="metric__content">
            <div className="metric__title">Caixa Atual</div>
            <div className="metric__value">{fmtBRL(caixaAtual)}</div>
            <div className="metric__sub green">+{fmtBRL(caixaVariacao)} hoje</div>
          </div>
        </div>

        <div className="card metric">
          <div className="metric__icon pink"><IconClientes /></div>
          <div className="metric__content">
            <div className="metric__title">Clientes</div>
            <div className="metric__value">{clientesAtendidos}</div>
            <div className="metric__sub">atendidos hoje</div>
          </div>
        </div>
      </section>

      {/* Conteúdo principal 2 colunas */}
      <div className="grid-2">
        <section className="panel">
          <div className="panel__title">Atividade Recente</div>
          <ul className="activity">
            {atividadeRecente.map((it, idx) => (
              <li key={idx} className="activity__item">
                <div className={`activity__icon ${it.tipo.toLowerCase()}`}>
                  {it.tipo === 'PAGAMENTO' && <IconCheck />}
                  {it.tipo === 'VENDA' && <IconCheck />}
                  {it.tipo === 'MOVIMENTO' && <IconCheck />}
                </div>
                <div className="activity__main">
                  <div className="activity__title">{it.titulo}</div>
                  <div className="activity__desc">{it.descricao}</div>
                </div>
                <div className="activity__value">{fmtBRL(it.valor)}</div>
              </li>
            ))}
          </ul>

          <div className="panel panel--spaced">
            <div className="panel__title">Resumo de Vendas</div>
            <div className="sales-summary">
              <div className="sales-summary__bar">
                <div
                  className="sales-summary__bar-fill"
                  style={{ width: `${resumoVendas.total ? (resumoVendas.finalizadas / resumoVendas.total) * 100 : 0}%` }}
                />
                <div className="sales-summary__bar-text">{resumoVendas.finalizadas}/{resumoVendas.total}</div>
              </div>
              <div className="sales-summary__legend">
                <div className="legend__item"><span className="dot done" /> {resumoVendas.finalizadas} Finalizadas</div>
                <div className="legend__item"><span className="dot pending" /> {resumoVendas.pendentes} Pendentes</div>
              </div>
            </div>
          </div>
        </section>

        <aside className="aside">
          <div className="panel">
            <div className="panel__title">Ações Rápidas</div>
            <div className="quick-actions">
              <button className="qa-item nova-cliente" onClick={() => navigate('/clientes')}>
                Nova Cliente
              </button>
              <button className="qa-item registrar-venda" onClick={() => navigate('/vendas')}>
                Registrar Venda
              </button>
              <button className="qa-item ver-comissoes" onClick={() => navigate('/comissoes')}>
                Ver Comissões
              </button>
            </div>
          </div>

          <div className="panel">
            <div className="panel__title with-icon">Alertas</div>
            <ul className="alerts">
              <li className="alert alert--warning">
                <div className="alert__title">Estoque baixo</div>
                <div className="alert__desc">Shampoo Kerastase — 2 unidades</div>
              </li>
              <li className="alert alert--info">
                <div className="alert__title">Conta em aberto</div>
                <div className="alert__desc">Ana Paula — R$ 150,00</div>
              </li>
              <li className="alert alert--neutral">
                <div className="alert__title">Comissão a pagar</div>
                <div className="alert__desc">Maria Silva — R$ 85,50</div>
              </li>
            </ul>
          </div>

          <div className="panel">
            <div className="panel__title">Resumo Financeiro</div>
            <div className="finance">
              <div className="finance__row">
                <span>Pagamentos Recebidos</span>
                <strong className="pos">{fmtBRL(980.00)}</strong>
              </div>
              <div className="finance__row">
                <span>Comissões Pendentes</span>
                <strong className="warn">{fmtBRL(247.50)}</strong>
              </div>
              <div className="finance__row total">
                <span>Saldo em Caixa</span>
                <strong>{fmtBRL(1450.00)}</strong>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
  // #endregion
}

// Ícone simples para o primeiro card (reusa vendasIcon)
function IconVendas() {
  return <IconDinheiro />;
}
